import React from "react";
import Button from "../elements/Button";
import { motion } from "framer-motion";
import { Fade } from "react-reveal";

export default function Hero(props) {
  function scrollToMessage() {
    if (props.refMessage.current) {
      window.scrollTo({
        top: props.refMessage.current.offsetTop,
        behavior: "smooth",
      });
    }
  }
  const box1Variant = {
    up: { y: -20 },
    down: {
      y: 15,
      transition: { yoyo: Infinity, duration: 1, ease: "easeInOut" },
    },
  };
  const box2Variant = {
    up: { y: 10 },
    down: {
      y: -20,
      transition: { yoyo: Infinity, duration: 1, ease: "easeInOut" },
    },
  };
  const flipVariant = {
    initial: { scaleX: -1 },
    animate: {
      scaleX: 0,
      transition: { yoyo: Infinity, duration: 1, ease: "easeInOut" },
    },
  };
  const eyeVariants = {
    close: { scale: 0.3 },
    open: {
      scale: 1,
      transition: { repeat: Infinity, repeatDelay: 2 },
    },
  };
  return (
    <div
      id="hero"
      className="lg:flex leading-relaxed items-center md:px-5 lg:px-0"
    >
      <Fade left cascade>
        <div className="pr-4 flex-1">
          <h1 className="text-3xl font-semibold text-center lg:text-left">
            Hi, I’m Gusti
          </h1>
          <p className="text-center md:mt-3 lg:text-left">
            I'm fullstack developer & UI/UX Designer, <br />I love to design and
            craft it with Javascript & its friends.
          </p>
          <div className="flex justify-center lg:justify-start mt-8">
            <Button isPrimary onClick={scrollToMessage}>
              Say Hello!
            </Button>
          </div>
        </div>
      </Fade>
      <div className="hidden lg:block flex-1">
        <svg
          width="31.25rem"
          height="31.25rem"
          viewBox="0 0 500 499"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M389.009 111.753C439.225 155.701 494.182 201.253 499.537 252.026C505.032 302.933 460.685 359.069 410.45 390.556C360.215 422.044 304.073 428.87 236.548 439.993C169.162 451.243 90.5196 466.917 44.9999 435.436C-0.519717 403.955 -13.012 325.307 15.3887 275.084C43.7894 224.862 113.159 203.129 158.71 159.048C204.262 115.106 225.963 48.9246 259.593 37.1295C293.222 25.2077 338.773 67.8119 389.009 111.753Z"
            fill="#F2F2F2"
          />
          <motion.path
            d="M459.253 19.0472H306.684V134.564H459.253V19.0472Z"
            fill="#5C5C5C"
            variants={box1Variant}
            initial={"up"}
            animate={"down"}
          />
          <motion.path
            d="M433.73 40.7675H389.053V120.867H433.73V40.7675Z"
            fill="white"
            variants={box1Variant}
            initial={"up"}
            animate={"down"}
          />
          <motion.path
            d="M374.342 58.3872C374.344 62.0318 373.264 65.5949 371.24 68.6258C369.216 71.6567 366.338 74.0192 362.971 75.4145C359.605 76.8098 355.899 77.1752 352.325 76.4645C348.75 75.7537 345.467 73.9988 342.89 71.4217C340.312 68.8446 338.558 65.5611 337.847 61.9865C337.136 58.4118 337.502 54.7067 338.897 51.3398C340.292 47.9729 342.655 45.0954 345.686 43.0714C348.716 41.0474 352.28 39.9677 355.924 39.9689C360.809 39.9689 365.494 41.9094 368.948 45.3635C372.402 48.8176 374.342 53.5024 374.342 58.3872Z"
            fill="#9F9F9F"
            variants={box1Variant}
            initial={"up"}
            animate={"down"}
          />
          <motion.path
            d="M461.097 255.056C461.097 263.97 458.454 272.684 453.502 280.095C448.549 287.507 441.51 293.284 433.275 296.695C425.04 300.106 415.978 300.999 407.235 299.26C398.492 297.521 390.462 293.228 384.158 286.925C377.855 280.622 373.563 272.591 371.824 263.849C370.085 255.106 370.977 246.044 374.389 237.809C377.8 229.573 383.577 222.534 390.988 217.582C398.4 212.63 407.114 209.986 416.028 209.986C427.981 209.986 439.444 214.735 447.897 223.187C456.349 231.639 461.097 243.103 461.097 255.056Z"
            fill="white"
            variants={flipVariant}
            initial="intial"
            animate="animate"
          />
          <path
            d="M489.016 171.35H392.444V267.922H489.016V171.35Z"
            stroke="#C4C4C4"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M234.101 498.854H473.729"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.17249 498.854H177.743"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M276.731 173.08L275.748 177.808L269.157 179.862C269.157 179.862 265.893 169.683 265.443 167.382C262.274 169.746 244.007 174.867 240.857 175.324C240.42 172.871 240.42 151.613 258.141 151.613C273.752 151.613 280.749 167.249 281.161 169.081C280.248 169.613 276.724 170.919 276.724 173.08"
            fill="#797979"
          />
          <path
            d="M281.11 214.005C277.149 214.005 248.4 243.014 247.221 249.086L237.961 296.995L285.921 283.577L288.735 222.555L281.902 213.986L281.11 214.005Z"
            fill="#9F9F9F"
          />
          <path
            d="M221.869 298.237C221.786 294.897 249.319 207.977 252.424 205.024C253.444 203.994 254.669 203.191 256.02 202.667C257.371 202.143 258.817 201.909 260.264 201.981C261.633 202.045 268.212 205.15 269.6 208.427C267.23 214.043 261.519 217.161 261.519 217.161L250.409 285.814L221.869 298.237Z"
            fill="white"
          />
          <path
            d="M255.422 350.361L295.212 399.614L275.913 419.014L217.502 367.949L231.319 348.935L255.422 350.361Z"
            fill="#3C3744"
          />
          <path
            d="M244.939 438.523C239.577 433.649 176.672 355.292 176.672 345.595C176.672 323.976 201.2 316.313 207.893 314.627C217.115 313.79 258.021 310.368 264.454 310.634C269.093 315.66 322.966 327.259 330.775 326.257C330.775 330.168 324.564 357.51 280.502 357.51C275.888 357.51 241.149 356.122 240.502 356.122C240.502 364.254 262.768 417.183 264.891 420.77"
            fill="#3C3744"
          />
          <path
            d="M301.943 199.833C337.607 199.833 345.327 264.17 345.327 282.43C345.327 305.709 335.883 324.312 331.383 326.055C318.638 330.954 271.85 314.906 268.884 307.307C254.421 270.293 278.226 199.833 301.969 199.833"
            fill="#9F9F9F"
          />
          <path
            d="M271.495 155.79C274.455 158.45 276.9 161.632 278.708 165.177C279.021 165.785 279.312 166.393 279.583 167.002"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M241.998 184.07C235.337 171.128 238.157 156.411 248.298 151.195C251.596 149.528 255.342 148.965 258.984 149.591"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M277.206 194.325C275.848 195.851 274.222 197.114 272.408 198.052C265.487 201.614 256.943 199.827 250.105 194.217"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M274.468 170.811C274.875 169.786 275.554 168.89 276.432 168.221C277.309 167.552 278.352 167.135 279.449 167.013C280.546 166.892 281.655 167.072 282.657 167.533C283.66 167.994 284.518 168.719 285.139 169.631C285.761 170.543 286.122 171.607 286.185 172.708C286.248 173.81 286.01 174.908 285.496 175.885C284.982 176.861 284.212 177.68 283.269 178.252C282.325 178.824 281.244 179.129 280.14 179.133C279.222 179.127 278.318 178.91 277.497 178.499"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M279.602 215.241C278.708 212.04 275.495 202.178 271.483 198.489"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M282.802 180.654C284.038 184.812 295.212 199.801 297.963 201.88C297.798 203.686 294.242 207.179 290.243 210.119"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M268.523 177.098L273.486 175.558L274.468 170.824"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M255.175 168.428C258.864 167.198 262.014 165.975 263.18 165.113C263.503 166.786 265.322 172.63 266.286 175.685"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M238.588 173.055C239.805 172.877 243.259 172.009 247.233 170.874"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M274.912 310.957C269.905 308.46 266.425 306.033 265.683 304.131C261.247 292.723 260.404 278.114 262.102 263.378"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M337.214 242.551C340.928 257.445 342.152 271.991 342.152 279.255C342.152 302.54 332.708 321.142 328.208 322.879C322.231 325.18 308.782 322.879 295.884 318.988"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M294.033 197.57C295.545 196.979 297.152 196.67 298.774 196.657C308.173 196.657 315.633 201.132 321.521 208.066"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M269.214 232.613C271.644 225.55 274.831 218.771 278.721 212.395"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M247.037 206.564C248.089 203.902 248.862 202.222 249.249 201.848C250.269 200.819 251.494 200.016 252.845 199.492C254.196 198.967 255.642 198.734 257.089 198.806C258.458 198.869 265.037 201.975 266.425 205.252"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M226.457 267.922C231.129 252.99 237.061 234.73 241.738 221.179"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M218.693 294.612C218.693 293.978 219.625 290.473 221.19 285.155"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M258.154 204.542C259.51 204.757 262.787 206.754 264.492 208.75"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M254.357 209.353C255.707 209.568 258.99 211.564 260.695 213.561"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M247.24 282.271C247.347 279.229 254.845 226.763 258.16 216.451"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M263.345 222.808C267.959 217.871 273.549 212.566 278.036 210.417"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.83 249.352L146.985 296.735"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M327.6 323.082C327.6 326.992 321.395 354.335 277.326 354.335C272.712 354.335 237.974 352.947 237.327 352.947C237.327 361.078 259.593 414.007 261.716 417.594"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M204.718 311.464C198.247 313.885 173.491 320.813 173.491 342.432C173.491 352.129 236.383 430.486 241.757 435.36"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M238.62 438.859L267.464 420.478"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M241.764 443.929L271.508 425.91"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M253.66 399.138L272.142 415.839"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M264.505 362.276L292.012 396.445"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M295.2 393.992L270.893 417.613"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M298.267 398.549L273.961 422.171"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.647 477.85V498.854"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.647 311.464V438.859"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M201.644 311.464V498.854"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M314.442 215.399C331.421 221.306 322.776 257.674 317.997 258.903C313.219 260.133 284.406 248.731 283.506 245.663C282.606 242.595 294.61 208.491 314.442 215.399Z"
            fill="#9F9F9F"
          />
          <path
            d="M292.886 217.586C297.798 212.661 304.009 209.695 311.266 212.224C328.246 218.131 319.601 254.498 314.816 255.728C310.031 256.957 281.224 245.555 280.324 242.488C280.109 241.765 280.609 239.319 281.769 236.074"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M285.49 247.45C284.108 249.479 276.458 274.216 276.458 274.216C276.458 274.216 222.414 297.521 219.72 298.725C218.738 297.381 215.505 294.922 208.946 294.922C196.935 294.922 194.856 302.889 194.856 304.6C194.856 306.312 213.116 310.114 218.015 309.994C222.914 309.873 291.422 299.454 293.869 298.231C296.315 297.007 312.712 258.301 312.712 258.301C308.275 258.067 287.822 251.735 285.502 247.457"
            fill="white"
          />
          <path
            d="M251.417 301.704C234.126 304.347 217.191 306.774 214.827 306.825C209.928 306.952 191.668 303.149 191.668 301.431C191.668 299.714 193.747 291.753 205.757 291.753C212.33 291.753 215.562 294.206 216.532 295.556C219.226 294.333 273.27 271.047 273.27 271.047C273.27 271.047 280.92 246.329 282.302 244.281"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M309.524 255.119C309.524 255.119 293.133 293.838 290.681 295.049C289.983 295.397 283.943 296.494 275.545 297.876"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M366.883 355.742H262.286V365.445H366.883V355.742Z"
            fill="black"
          />
          <path
            d="M324.564 362.276H259.104V352.573H363.682V362.276H345.302"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M235.438 306.185H76.2971V314.171H235.438V306.185Z"
            fill="black"
          />
          <path
            d="M117.83 303.466H232.719V311.464H73.5781V303.478H98.0682"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M205.764 299.466H149.717V306.185H205.764V299.466Z"
            fill="#6666CC"
          />
          <path
            d="M203.045 296.747H146.998V303.466H203.045V296.747Z"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M247.227 445.723L265.607 465.82L255.555 493.708L286.39 469.731L268.517 432.863"
            fill="white"
          />
          <path
            d="M276.033 451.737L265.328 429.668"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M244.058 442.547L262.438 462.645L252.393 490.532L283.221 466.556L280.077 460.091"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M297.589 405.464L307.825 422.842L314.892 426.518L301.443 457.752L298.375 438.104L280.628 421.923"
            fill="white"
          />
          <path
            d="M282.042 422.887L277.51 418.748"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M294.414 402.294L304.65 419.667L311.716 423.349L298.267 454.583L295.2 434.935L291.397 431.462"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M286.117 362.276V497.91"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M336.701 414.045V497.929"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M336.701 362.276V390.848"
            stroke="#6A6A6A"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <motion.path
            d="M255.555 175.52C255.866 176.598 256.588 177.333 257.171 177.162C257.755 176.991 257.983 175.989 257.672 174.918C257.362 173.847 256.645 173.105 256.056 173.296C255.467 173.486 255.251 174.468 255.555 175.539"
            fill="#6A6A6A"
            variants={eyeVariants}
            initial="close"
            animate="open"
          />
          <path
            d="M248.52 187.366C248.444 187.766 248.32 188.155 248.152 188.526"
            stroke="#6A6A6A"
            strokeWidth="3.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M247.848 181.085C248.352 182.484 248.63 183.953 248.672 185.439"
            stroke="#6A6A6A"
            strokeWidth="3.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M265.189 186.757C265.373 188.177 264.378 190.383 262.457 191.669"
            stroke="#6A6A6A"
            strokeWidth="3.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <motion.path
            variants={box2Variant}
            initial={"up"}
            animate={"down"}
            d="M180.26 160.252H13.2972V210.626H180.26V160.252Z"
            fill="black"
          />
          <motion.path
            variants={box2Variant}
            initial={"up"}
            animate={"down"}
            d="M165.898 185.186C165.899 188.094 165.038 190.938 163.423 193.357C161.808 195.776 159.512 197.661 156.825 198.775C154.138 199.889 151.181 200.181 148.329 199.614C145.476 199.048 142.855 197.648 140.798 195.592C138.741 193.536 137.34 190.915 136.772 188.063C136.204 185.21 136.495 182.254 137.608 179.566C138.721 176.879 140.605 174.582 143.024 172.966C145.442 171.35 148.285 170.488 151.193 170.488C155.092 170.488 158.831 172.036 161.589 174.792C164.346 177.549 165.896 181.287 165.898 185.186Z"
            fill="white"
          />
          <motion.path
            variants={box2Variant}
            initial={"up"}
            animate={"down"}
            d="M123.42 176.661H40.4302"
            stroke="white"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <motion.path
            variants={box2Variant}
            initial={"up"}
            animate={"down"}
            d="M123.42 193.717H79.447"
            stroke="white"
            strokeWidth="3.69"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M237.333 -1H138.105V124.911H237.333V-1Z" fill="white" />
          <path
            d="M176.672 44.1457L205.764 112.527L266.831 70.1316L176.672 44.1457Z"
            stroke="#C4C4C4"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M90.0949 62.2978H32.9577V86.1604H90.0949V62.2978Z"
            fill="white"
          />
          <path
            d="M63.5069 91.795H6.36969V115.658H63.5069V91.795Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
}
